import { Box, Typography } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';
import { HeaderDetailsProps } from '../types/props';
import { HeaderContainer } from './HeaderContainer';

type HeaderProps = {
	headerDetails: HeaderDetailsProps;
} & PropsWithChildren;

const headerStyles = {
	display: 'flex',
	alignItems: 'center',
	marginRight: '10px',
};

const headerInfoStyles = {
	paddingLeft: '15px',
	fontSize: '18px',
};

export const HeaderDetails: FC<HeaderProps> = ({ headerDetails }) => (
	<HeaderContainer id='pca__header'>
		<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
				}}
				id='pca__header-center--title'
			>
				<Box style={headerStyles}>
					<Typography style={headerInfoStyles} variant='body1' data-cy='header-left-top-details-text'>
						{headerDetails?.info ? `${headerDetails.info} |` : null}
					</Typography>
				</Box>
				<Typography variant='body1' data-cy='header-left-bottom-details-text'>
					{headerDetails?.description || null}
				</Typography>
			</div>

			<div id='pca__header-right--actions'>
				<div data-cy='header-right-details-text'>{headerDetails?.leftSideInfo || ''}</div>
				<div
					id='pca__detail-header-settings_link'
					style={{ display: 'flex', alignItems: 'center', gap: '15px' }}
				>
					{headerDetails?.rightSideInfo || ''}
				</div>
			</div>
		</div>
	</HeaderContainer>
);
